import React from 'react';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';



const styles = theme => ({
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 50,
    },
    button: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class SimpleMessage extends React.Component {

    constructor(props) {
        super(props);

        this.myRef = React.createRef();

        this.state = {}
    }

    componentDidMount = () =>{
        this.myRef.current.focus();
    }

    renderException = () => {
        if (!this.props.exception) {
            return null;
        }

        return (<Typography variant="subtitle2" gutterBottom align='center'>{this.props.exception}</Typography>);
    }

    render() {

        const { classes } = this.props;

        return (
            <div>
                <Typography style={{whiteSpace: 'pre-line'}} variant="body1" gutterBottom align='center'>{this.props.message}</Typography>

                <div className={classes.buttonContainer}>
                    <Button buttonRef={this.myRef} variant="contained" color="secondary" className={classes.button} onClick={() => this.props.hideDialog()}>Cerrar</Button>
                </div>
            </div>
        )

    }

}

SimpleMessage.propTypes = {
    message: PropTypes.string.isRequired,
    exception: PropTypes.string,
    hideDialog: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(SimpleMessage);